import { render, staticRenderFns } from "./HomeRecomment.vue?vue&type=template&id=4c55e8b6&scoped=true&"
import script from "./HomeRecomment.vue?vue&type=script&lang=js&"
export * from "./HomeRecomment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c55e8b6",
  null
  
)

export default component.exports